module.exports = __webpack_public_path__ + "static/img/ic_file_ppt.1a603591.png";